import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Root } from './pages/Root';
import {MarkettingRoot} from './pages/MarkettingRoot'
import { Home } from './components/Home/Home';
import { AboutUs } from './components/AboutUs/AboutUs';
import { ContactUs } from './components/ContactUs/ContactUs';
import { FAQ } from './components/FAQ/FAQ';
import { ArticlesPage } from './components/Articles/ArticlesPage';
import PlaceOrderForm from './components/Forms/PlaceOrderForm';
import ArticleDetails from './components/Articles/ArticleComponents/ArticleDetails';
import CampaignForm from './components/Forms/CampaignForm';
import { Provider } from 'react-redux';
import store from './redux/store/store';
import MissionDetails from './components/AboutUs/AboutUsComponents/MissionDetails';
import PostcardForm from './components/Forms/PostcardForm';
import FoldedMailerForm from './components/Forms/FoldedMailer';
import FlatSizedMailerForm from './components/Forms/FlatSizedMailerForm';
import LettersInEnvelopeForm from './components/Forms/LettersInEnvelopeForm';
import { LandingPage } from './components/LandingPage/LandingPage';

function App() {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Root />,
      children: [
        {
          path: '',
          element: <Home />
        },
        {
          path: 'about-us',
          element: <AboutUs />
        },
        {
          path: 'contact-us',
          element: <ContactUs />
        },
        {
          path: 'faq',
          element: <FAQ />
        },
        {
          path: 'articles',
          element: <ArticlesPage />
        },
        {
          path: 'place-order',
          element: <PlaceOrderForm />
        },
        {
          path: 'get-started',
          element: <CampaignForm />
        },
        {
          path: 'folded-mailers',
          element: <FoldedMailerForm />
        },
        {
          path: 'postcard',
          element: <PostcardForm />
        },
        {
          path: 'flat-sized-mailers',
          element: <FlatSizedMailerForm />
        },
        {
          path: 'letters-in-envelopes',
          element: <LettersInEnvelopeForm />
        },
        {
          path: 'article-details/:id',
          element: <ArticleDetails />
        },
        {
          path: 'our-mission',
          element: <MissionDetails title="Our Mission" />
        },
        {
          path: 'our-vision',
          element: <MissionDetails title={"Our Vision"} />
        },
      ]
    },
    {
      path: '/',
      element: <MarkettingRoot />,
      children: [
        {
          path: 'political-direct-mail-marketing',
          element: <LandingPage />
        },
      ]
    },
  ]);

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}


export default App;